import { render } from "./AccountDropdown.vue?vue&type=template&id=dfe5bc24&scoped=true"
import script from "./AccountDropdown.vue?vue&type=script&lang=js"
export * from "./AccountDropdown.vue?vue&type=script&lang=js"

import "./AccountDropdown.vue?vue&type=style&index=0&id=dfe5bc24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfe5bc24"]])

export default __exports__